(function () {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			const alwaysOpen = targetDetail.closest('.accordion--always-open');

			if (alwaysOpen) {
				targetDetail.setAttribute('open', '');
				const summary = targetDetail.querySelector('summary');
				if (summary) {
					summary.addEventListener('click', (event) => {
						event.preventDefault();
						targetDetail.setAttribute('open', '');
					});
				}
				return;
			}

			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail && !detail.closest('.accordion--always-open')) {
						detail.removeAttribute('open');
					}
				});
			});
		});

	}

	document.addEventListener('shopify:section:load', footer);
	footer();

})();
